import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SendToField({
  userEmail
}) {
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.exportSubmissions.sendTo"
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      readOnly: true,
      defaultValue: userEmail
    })
  });
}